function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var StarFull = function StarFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M17.67 22.47c-.302 0-.585-.075-.868-.228L12.2 19.754a.38.38 0 0 0-.358.001l-4.6 2.487c-.523.314-1.303.305-1.91-.101a1.81 1.81 0 0 1-.745-1.742l.917-5.4a.37.37 0 0 0-.104-.328l-3.898-3.897a1.77 1.77 0 0 1-.412-1.797c.205-.615.767-1.078 1.43-1.181l5.302-.789a.38.38 0 0 0 .283-.209l2.305-4.776A1.79 1.79 0 0 1 12.045 1c.682 0 1.322.399 1.632 1.019l2.307 4.801c.054.113.16.191.283.209l5.299.79c.664.102 1.225.564 1.43 1.176.226.605.07 1.292-.406 1.796l-3.923 3.881a.38.38 0 0 0-.106.329l.896 5.395c.102.694-.183 1.362-.744 1.743a1.75 1.75 0 0 1-1.043.331",
    clipRule: "evenodd"
  }));
};
export default StarFull;